<app-textarea-field
  *ngIf="!useNewDesign"
  [alignment]="alignment"
  [label]="label"
  [fieldId]="fieldId"
  [textareaE2eId]="e2eId"
  [placeholder]="placeholder"
  [fieldControl]="fieldControl"
  [maxlength]="maxlength"
  [condensed]="condensed"
  [removeNativeAutocomplete]="true"
  [focusableTrigger$]="focusableTrigger$"
  [options]="autoCompleteOptions"
  [trackingObject]="trackingObject"
  [trackingAction]="trackingAction"
  (onAutoCompleteSet)="trackAutoCompleteSelect($event)"
></app-textarea-field>

<i2g-textarea-field
  *ngIf="useNewDesign"
  [autoCompleteOptions]="autoCompleteOptions?.autoComplete"
  [removeNativeAutocomplete]="true"
  [label]="label"
  [fieldId]="fieldId"
  [textareaE2eId]="e2eId"
  [placeholder]="placeholder"
  [fieldControl]="fieldControl"
  [maxlength]="maxlength"
  [focusableTrigger$]="focusableTrigger$"
  [trackingObject]="trackingObject"
  [trackingAction]="trackingAction"
  [showCounter]="false"
  (autoCompleteSet)="trackAutoCompleteSelect($event)"
></i2g-textarea-field>
